import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/navbar/Navbar';
import Jobportal from './components/jobs/jobportal/Jobportal';
import Home from './components/home/Home'; // Import the new Home component
import Bewerbung from './components/jobs/bewerbung/Bewerbung';
import ZuteilungZelt from './components/jobs/zuteilung_zelt/Zuteilung_zelt'; // Correct file path
import ZuteilungJob from './components/jobs/zuteilung_job/Zuteilung_job'; // Correct file path
import { DatabaseProvider } from './context/DatabaseContext'; // Import the DatabaseProvider
import Stellenausschreibungen from './components/jobs/stellenausschreibungen/Stellenausschreibungen'; // Import the Stellenausschreibungen component
import Freizeitangebote from './components/freizeit/freizeitangebote/Freizeitangebote'; // Import the Freizeitangebote component
import Parlament from './components/parlament/Parlament'; // Import the Parlament component
import Notfallnummern from './components/notfallnummern/Notfallnummern'; // Import the Notfallnummern component
import Dienstplaene from './components/dienstplaene/Dienstplaene'; // Import the Dienstplaene component
import LogistikDienstplaene from './components/dienstplaene/logistik/LogistikDienstplaene';
import Zeltsprecher from './components/parlament/zeltsprecher/Zeltsprecher';
import Stadtplan from './components/stadtplan/Stadtplan'; // Import the Stadtplan component
import Selbstständigkeit from './components/jobs/selbstständigkeit/Selbstständigkeit'; // Import the Selbstständigkeit component
import Pabrika from './components/parlament/pabrika/Pabrika'; // Import the Pabrika component
import Kinder from './components/parlament/kinder/Kinder'; // Import the Kinder component
import PabrikaAuslesen from './components/parlament/pabrika/PabrikaAuslesen'; // Import the PabrikaAuslesen component
import Antraege from './components/parlament/antraege/Antraege'; // Import the Antraege component
import Ausschuesse from './components/parlament/ausschuesse/Ausschuesse'; // Import the Ausschuesse component
import Spuelplan from './components/dienstplaene/Spuelplan';
import Speiseplan from './components/speiseplan/Speiseplan';
import Tagesablauf from './components/tagesablauf/Tagesablauf';
import ProtectedRoute from './ProtectedRoute';
import Inventar from './components/logistik/Inventar';
import Freizeit from './components/freizeit/Freizeit';
import Kinderliste from './components/jobs/kinderliste/KinderListe';
import KindDetail from './components/jobs/kinderliste/KindDetail';

export const host_url = "/api";
export const zb_password = process.env.REACT_APP_ZB_PASSWORD || 'default_password';
export const parlament_password = process.env.REACT_APP_PARLAMENT_PASSWORD || 'default_password';

function App() {

  return (
    <DatabaseProvider> {/* Wrap the application in the DatabaseProvider */}
      <Router>
        <Navbar />
        <Routes>
          <Route
            path="/jobportal"
            element={
              <ProtectedRoute>
                <Jobportal />
              </ProtectedRoute>
            }
          />
          <Route
            path="/jobs/bewerbung"
            element={
              <ProtectedRoute>
                <Bewerbung />
              </ProtectedRoute>
            }
          />
          <Route
            path="/jobs/zuteilung_zelt"
            element={
              <ProtectedRoute>
                <ZuteilungZelt />
              </ProtectedRoute>
            }
          />
          <Route
            path="/jobs/zuteilung_job"
            element={
              <ProtectedRoute>
                <ZuteilungJob />
              </ProtectedRoute>
            }
          />
          <Route
            path="/jobs/stellenausschreibungen"
            element={
              <ProtectedRoute>
                <Stellenausschreibungen />
              </ProtectedRoute>
            }
          />
          <Route
            path="/freizeit"
            element={
              <ProtectedRoute>
                <Freizeit />
              </ProtectedRoute>
            }
          />
          <Route
            path="/freizeitangebote"
            element={
              <ProtectedRoute>
                <Freizeitangebote />
              </ProtectedRoute>
            }
          />
          <Route
            path="/parlament"
            element={
              <ProtectedRoute>
                <Parlament />
              </ProtectedRoute>
            }
          />
          <Route
            path="/parlament/selbstständigkeit"
            element={
              <ProtectedRoute>
                <Selbstständigkeit />
              </ProtectedRoute>
            }
          />
          <Route
            path="/parlament/pabrika"
            element={
              <ProtectedRoute>
                <Pabrika />
              </ProtectedRoute>
            }
          />
          <Route path="/notfallnummern" element={<Notfallnummern />} /> {/* Add this line */}
          <Route
            path="/dienstplaene"
            element={
              <ProtectedRoute>
                <Dienstplaene />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dienstplaene/logistik"
            element={
              <ProtectedRoute>
                <LogistikDienstplaene mode="hub" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dienstplaene/logistik/person"
            element={
              <ProtectedRoute>
                <LogistikDienstplaene mode="person" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dienstplaene/logistik/tag"
            element={
              <ProtectedRoute>
                <LogistikDienstplaene mode="tag" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dienstplaene/logistik/dienst"
            element={
              <ProtectedRoute>
                <LogistikDienstplaene mode="dienst" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dienstplaene/logistik/gesamt"
            element={
              <ProtectedRoute>
                <LogistikDienstplaene mode="gesamt" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dienstplaene/logistik/fahrten"
            element={
              <ProtectedRoute>
                <LogistikDienstplaene mode="fahrten" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dienstplaene/logistik/matrix"
            element={
              <ProtectedRoute>
                <LogistikDienstplaene mode="matrix" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/jobs/zeltsprecher"
            element={
              <ProtectedRoute>
                <Zeltsprecher />
              </ProtectedRoute>
            }
          />
          <Route
            path="/jobs/kinderliste"
            element={
              <ProtectedRoute>
                <Kinderliste />
              </ProtectedRoute>
            }
          />
          <Route
            path="/jobs/kinderliste/kind/:kindId"
            element={
              <ProtectedRoute>
                <KindDetail />
              </ProtectedRoute>
            }
          />
          <Route path="/speiseplan" element={<Speiseplan />} />
          <Route path="/tagesablauf" element={<Tagesablauf />} />
          <Route path="/stadtplan" element={<Stadtplan />} />
          <Route
            path="/parlament/kinder"
            element={
              <ProtectedRoute>
                <Kinder />
              </ProtectedRoute>
            }
          />
          <Route
            path="/parlament/pabrika_auslesen"
            element={
              <ProtectedRoute>
                <PabrikaAuslesen />
              </ProtectedRoute>
            }
          />
          <Route
            path="/parlament/antraege"
            element={<Antraege />}
          />
          <Route
            path="/parlament/ausschuesse"
            element={
              <ProtectedRoute>
                <Ausschuesse />
              </ProtectedRoute>
            }
          />
          <Route
            path="/spuelplan"
            element={
              <ProtectedRoute>
                <Spuelplan />
              </ProtectedRoute>
            }
          />
          <Route path="/logistik/inventar" element={<Inventar />} />
          <Route path="*" element={<Home />} /> {/* Default route */}
        </Routes>
      </Router>
    </DatabaseProvider>
  );
}

export default App;
